// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"j_n","noSpacing":"j_p"};